import { render, staticRenderFns } from "./access_rules.vue?vue&type=template&id=4711d885"
import script from "./access_rules.vue?vue&type=script&lang=js"
export * from "./access_rules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports